import React, { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import SellingService from "../../services/SellingService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../components/layouts/WithLoader";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const StockOfProductSale = ({
  setOnGetStockProduct,
  idProduct,
  nameProduct,
  idWarehouse,
  startLoading, stopLoading 
}) => {
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [virualStock, setVirualStock] = useState();
  const [realStock, setRealStock] = useState();

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnGetStockProduct(false);
  };

  useEffect(() => {
    SellingService.getStockForProduct(
      getCurrentUserId(),
      idProduct,
      idWarehouse
    )
      .then((response) => {

        if (!response.data.error) {
            console.log("getStockForProduct", response.data)
          setOpenAlert(true);
          setRealStock(response.data.realQte);
          setVirualStock(response.data.virtualQte);
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  }, []);

  return (
    <>
      <div class="modal fade" id="edit-brand">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">La disponibilité du produit</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Produit : {nameProduct}</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">
                      Stock réel : {realStock}
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">
                      Stock commandé : {virualStock}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withLoader(StockOfProductSale);
